import React from 'react';
import dayjs from 'dayjs';
import { FORMAT_DATE_TIME_II } from 'constants';
import CurrencyAmount from 'pages/Transactions/common/CurrencyAmount';
import StripeStatus from 'pages/Transactions/common/StripeStatus';

const renderCurrencyAmount = (data, amount) => (
  <CurrencyAmount amount={amount} symbol={data?.currencySymbol} />
);

export const subsidyTransactionRows = [
  {
    name: 'receiptNumber',
    label: 'Receipt #',
    formatter: data =>
      data.receiptUrl ? (
        <a href={data.receiptUrl} target="_blank" rel="noopener noreferrer" className="fs--0">
          {data.receiptNumber}
        </a>
      ) : (
        data.receiptNumber
      )
  },
  {
    name: 'transactionTime',
    label: 'Date/time',
    formatter: data => (
      <>{data.transactionTime ? dayjs(data.transactionTime).format(FORMAT_DATE_TIME_II) : ''}</>
    )
  },
  {
    name: 'transactionStatus',
    label: 'Status',
    formatter: data => <StripeStatus status={data?.transactionStatus} />
  },
  {
    name: 'driverAccreditation',
    label: 'Driver Accreditation'
  },
  {
    name: 'driverName',
    label: 'Driver Name'
  },
  {
    name: 'businessRegistrationId',
    label: 'Driver Tax ID'
  },
  {
    name: 'vehiclePlateNumber',
    label: 'Vehicle ID'
  },
  {
    name: 'state',
    label: 'State'
  },
  {
    name: 'country',
    label: 'Country'
  },
  {
    name: 'fleetName',
    label: 'Fleet Name'
  },
  {
    name: 'companyName',
    label: 'Company'
  },
  {
    name: 'groupName',
    label: 'Group'
  },
  {
    name: 'pickUpLocation',
    label: 'Pickup Location'
  },
  {
    name: 'dropOffLocation',
    label: 'Drop off location'
  },
  {
    name: 'cardType',
    label: 'Card Type'
  },
  {
    name: 'cardNumber',
    label: 'Card Number',
    formatter: data => <>{data.cardNumber}</>
  },
  {
    name: 'fare',
    label: 'Fare Amount',
    formatter: data => renderCurrencyAmount(data, data.fare)
  },
  {
    name: 'extras',
    label: 'Extras Amount',
    formatter: data => renderCurrencyAmount(data, data.extras)
  },
  {
    name: 'tip',
    label: 'Tip Amount',
    formatter: data => renderCurrencyAmount(data, data.tip)
  },
  {
    name: 'voucherDiscount',
    label: 'Discount Voucher',
    formatter: data => renderCurrencyAmount(data, data.voucherDiscount)
  },
  {
    name: 'currency',
    label: 'Currency'
  },
  {
    name: 'faceValue',
    label: 'Face Value',
    formatter: data => renderCurrencyAmount(data, data.faceValue)
  },
  {
    name: 'amount',
    label: 'Amount',
    formatter: data => renderCurrencyAmount(data, data.amount)
  },
  {
    name: 'liftingFee',
    label: 'Lifting Fee',
    formatter: data => renderCurrencyAmount(data, data.liftingFee)
  },
  {
    name: 'balancePayment',
    label: 'Balance Payment',
    formatter: data => renderCurrencyAmount(data, data.balancePayment)
  }
];

export const subsidyPaymentRows = [
  {
    name: 'stripePaymentNetwork',
    label: 'Network',
    formatter: data => <>{data?.stripeInfo?.stripePaymentNetwork}</>
  }
];

export const renderRows = (data, config) => (
  <>
    {config.map(item => (
      <tr key={item.name}>
        <td className="bg-100 w-50 text-start">{item.label}</td>
        <td className={item.formatterClass || ''}>
          {item.formatter ? item.formatter(data || {}) : data?.[item.name]}
        </td>
      </tr>
    ))}
  </>
);
